/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.BusinessInfo {
    angular.module("meevo.plugins.businessInfo", []);
}